<template>
  <div class="product-price-graph-page col-block" v-if="datas">
    <div class="option-container row-block">
      <div class="data-block row-block">
        <template v-if="conditions.filters.crop_name">
          <div><b>作物(產品)：</b>{{ getFilterTitle('crop_name') }}</div>
          <div :style="{ width: '50px' }"></div>
        </template>
      </div>
      <div :style="{ flex: 1 }"></div>
      <div class="option-block row-block">
        <div class="option row-block input-group">
          <div class="option-title">字體</div>
          <div :style="{ width: '8.5px' }"></div>
          <select v-model="fontSize">
            <option value="14">小</option>
            <option value="16">中</option>
            <option value="20">大</option>
          </select>
        </div>
      </div>
      <div :style="{ width: '15px' }"></div>
      <div class="button-block row-block">
        <template v-if="rolePermission(['advance', 'admin'])">
          <button type="button" name="button" class="main-button option-button update" @click="e => downloadData()">
            <span>原始數據下載</span>
          </button>
          <div :style="{ width: '15px' }"></div>
        </template>
        <button type="button" name="button" class="main-button option-button update" @click="e => downloadGraph()">
          <span>另存圖檔</span>
        </button>
      </div>
    </div>
    <div class="content-container" :style="{ flex: 1 }">
      <div class="graph-block row-block stretch">
        <div class="options-container col-block" :style="{ width: '210px' }">
          <div class="options-block col-block" :style="{ flex: 1, height: 0 }">
            <div :style="{ height: 0, width: '100%' }">
              <div class="options col-block">
                <div class="filter-container col-block">
                  <div class="filter-title-container row-block">
                    <div class="filter-title">X軸</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="filter-forms input-group col-block">
                    <select v-model="filterConditions['xAxis']">
                      <option v-for="(option, index) in xAxisOptions" :key="index" :value="option.value">{{ option.title }}</option>
                    </select>
                  </div>
                  <div :style="{ height: '15px' }"></div>
                  <div class="filter-options">
                    <graphOptions
                      :name="'xAxis'"
                      :countryOptions="countryOptions"
                      :createOptions="xAxisGraphOptions.createOptions"
                      :checkOptions="xAxisGraphOptions.checkOptions"
                      @create="value => (options[filterConditions['xAxis']] || []).push(value)"
                      @remove="value => (options[filterConditions['xAxis']] || []).splice((options[filterConditions['xAxis']] || []).indexOf(value), 1)"
                      @select="value => filterConditions[filterConditions['xAxis']] = value"
                    ></graphOptions>
                  </div>
                </div>
                <div :style="{ height: '15px' }"></div>
                <div class="filter-container col-block">
                  <div class="filter-title-container row-block">
                    <div class="filter-title">Y軸</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="filter-forms input-group col-block">
                    <div class="data-lists col-block">
                      <div :style="{ height: '7px' }"></div>
                      <label class="data-block row-block" v-for="(data, index) in yAxisCheckOptions" :key="index" :for="'yAxis-select-' + data.value">
                        <input type="checkbox" v-show="false" :id="'yAxis-select-' + data.value" :value="data.value" v-model="filterConditions['yAxis']">
                        <img :src="require('../../assets/images/checkbox-' + (filterConditions['yAxis'].includes(data.value) ? 'true' : 'false') + '.svg')">
                        <div :style="{ width: '8px' }"></div>
                        <div class="data-title" :style="{ flex: 1 }" :title="data.title">{{ data.title }}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div :style="{ height: '15px' }"></div>
                <div class="filter-container col-block">
                  <div class="filter-title-container row-block">
                    <div class="filter-title">Z軸</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="filter-forms input-group col-block">
                    <select v-model="filterConditions['zAxis']">
                      <option v-for="(option, index) in zAxisOptions" :key="index" :value="option.value">{{ option.title }}</option>
                    </select>
                  </div>
                  <div :style="{ height: '15px' }"></div>
                  <div class="filter-options">
                    <graphOptions
                      :name="'zAxis'"
                      :countryOptions="countryOptions"
                      :createOptions="zAxisGraphOptions.createOptions"
                      :checkOptions="zAxisGraphOptions.checkOptions"
                      @create="value => (options[filterConditions['zAxis']] || []).push(value)"
                      @remove="value => (options[filterConditions['zAxis']] || []).splice((options[filterConditions['zAxis']] || []).indexOf(value), 1)"
                      @select="value => filterConditions[filterConditions['zAxis']] = value"
                    ></graphOptions>
                  </div>
                </div>
                <div :style="{ height: '15px' }"></div>
                <div class="filter-container col-block">
                  <div class="filter-title-container row-block">
                    <div class="filter-title">計價方式</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="filter-forms input-group col-block">
                    <div class="data-lists col-block">
                      <div :style="{ height: '7px' }"></div>
                      <label class="data-block row-block" v-for="(data, index) in otherCheckOptions" :key="index" :for="'other-select-' + data.value">
                        <input type="checkbox" v-show="false" :id="'other-select-' + data.value" :value="data.value" v-model="filterConditions['other']">
                        <img :src="require('../../assets/images/checkbox-' + (filterConditions['other'].includes(data.value) ? 'true' : 'false') + '.svg')">
                        <div :style="{ width: '8px' }"></div>
                        <div class="data-title" :style="{ flex: 1 }" :title="data.title">{{ data.title }}</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div :style="{ height: '15px' }"></div>
                <div class="filter-container col-block">
                  <div class="filter-title-container row-block">
                    <div class="filter-title">日期起始與結束</div>
                    <div :style="{ flex: 1 }"></div>
                    <a
                      v-if="filterConditions['range'].start || filterConditions['range'].end"
                      class="filter-reset link"
                      @click="e => filterConditions['range'] = { start: '', end: '' }"
                    >{{ '重設' }}</a>
                  </div>
                  <div :style="{ height: '5px' }"></div>
                  <div class="filter-forms input-group col-block">
                    <input type="date" :style="filterConditions['range'].start ? {} : { color: '#777777' }" :placeholder="'請選擇起始日'" v-model="filterConditions['range'].start">
                    <span :style="{ opacity: 0, height: '5px' }">~</span>
                    <input type="date" :style="filterConditions['range'].end ? {} : { color: '#777777' }" :placeholder="'請選擇結束日'" v-model="filterConditions['range'].end">
                  </div>
                </div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="chart-container" :style="{ flex: 1 }">
          <div class="chart-block">
            <div ref="chartField" class="chart-field" :style="{ '--chart-font-size': fontSize + 'px' }">
              <div class="chart-block col-block">
                <div class="main-chart-container row-block stretch">
                  <div class="main-chart-block col-block" :style="{ flex: 1 }">
                    <div class="data-block col-block">
                      <b>{{ [[filterConditions['range'].start, filterConditions['range'].end].filter(x => x).join('~'), getFilterTitle('crop_name') + '的零售價格分析'].filter(x => x).join(' ') }}</b>
                    </div>
                    <div class="chart-block">
                      <vueCharts
                        ref="chart"
                        :options="chartOptions"
                        :autoresize="true"
                        @click="param => chartOnClick(param)"
                      ></vueCharts>
                    </div>
                  </div>
                  <div :style="{ width: '20px' }"></div>
                  <div class="legend-container col-block" :style="{ width: '170px' }">
                    <div :style="{ height: '35px' }"></div>
                    <div class="zAxis-container col-block">
                      <div class="axis-title"><b>Z軸：</b>{{ zAxisOptions.find(option => option.value === filterConditions['zAxis']).title }}</div>
                      <div :style="{ height: '10px' }"></div>
                      <div class="axis-legend-container col-block">
                        <div class="axis-legend row-block" v-for="(legend, index) in zAxisLegends" :key="index">
                          <div class="legend-icon" :style="{ background: legend.color }"></div>
                          <div :style="{ width: '8.5px' }"></div>
                          <div class="legend-title">{{ legend.title }}</div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                    <div :style="{ height: '20px' }"></div>
                    <div class="other-container col-block">
                      <div class="axis-title"><b>計價方式</b></div>
                      <div :style="{ height: '10px' }"></div>
                      <div class="axis-legend-container col-block">
                        <div class="axis-legend row-block" v-for="(legend, index) in otherLegends" :key="index">
                          <div class="legend-icon">
                            <img :src="legend.icon" alt="">
                          </div>
                          <div :style="{ width: '8.5px' }"></div>
                          <div class="legend-title">{{ legend.title }}</div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                  <div :style="{ width: '10px' }"></div>
                </div>
                <div :style="{ flex: 1 }"></div>
                <div class="description-block row-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="col-block">
                    <div class="content">資料來源：本平台資料庫</div>
                    <div class="title">農業部農業試驗所</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { API_ROOT } from '../../api/config'
import { postAccessLog } from '../../api'
import vueCharts from 'vue-echarts'
import echarts from 'echarts'
import 'echarts/lib/chart/bar'
import graphOptions from './graphOptions'
import customFilter from '../tool/customFilter'
import userPermission from '../../mixins/userPermission'
import toastMethods from '../../mixins/toastMethods'
import { html2DataUrl, downloadFile, dateFormat } from '../../constants/global/util'

export default {
  components: {
    vueCharts,
    graphOptions,
    customFilter
  },
  mixins: [
    userPermission,
    toastMethods
  ],
  props: {
    datas: {
      type: Array,
      default: () => null
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      echarts: echarts,
      fontSize: '14',
      filtedDatas: [],
      options: {},
      filterConditions: {}
    }
  },
  computed: {
    ...mapGetters([
      'countrys'
    ]),
    // static
    colors () {
      return [
        [
          '#36A2DA',
          '#3966A6',
          '#9CCECB',
          '#85B84F',
          '#3A9171',
          '#29463C',
          '#FFB700',
          '#FF7D0D',
          '#ED92BF',
          '#CC292E',
          '#DABE7F',
          '#6A0E1C',
          '#B38039',
          '#C37FE6'
        ],
        [
          '#85B84F',
          '#FFB700',
          '#ED92BF',
          '#FF7D0D',
          '#36A2DA',
          '#29463C',
          '#CC292E',
          '#C37FE6',
          '#3A9171',
          '#9CCECB',
          '#6A0E1C',
          '#DABE7F',
          '#3966A6',
          '#B38039'
        ]
      ]
    },
    xAxisOptions () {
      return [
        { title: '市場所在國家', value: 'marketCountry' },
        { title: '包裝類型', value: 'packingMethod' },
        { title: '市場類型', value: 'marketKind' },
        { title: '產地', value: 'country' }
      ].filter(option => this.filterConditions['zAxis'] !== option.value)
    },
    yAxisCheckOptions () {
      return [
        { title: '單價價格', value: 'single' },
        { title: '總價價格', value: 'all' }
      ]
    },
    zAxisOptions () {
      return [
        { title: '市場所在國家', value: 'marketCountry' },
        { title: '包裝類型', value: 'packingMethod' },
        { title: '市場類型', value: 'marketKind' },
        { title: '產地', value: 'country' }
      ].filter(option => this.filterConditions['xAxis'] !== option.value)
    },
    otherCheckOptions () {
      return [
        { title: '重量計價', value: 'price_by_weight', icon: require('../../assets/images/product-price-circle.svg') },
        { title: '數量計價', value: 'price_by_count', icon: require('../../assets/images/product-price-triangle.svg') }
      ]
    },
    countryOptions () {
      return this.countrys.map(([key, value]) => ({
        title: value.chinese_name + '(' + value.iso_name + ')',
        value: key,
        country: value
      }))
    },
    marketCountryCheckOptions () {
      return this.countryOptions.filter(option => this.options.marketCountry.includes(option.title))
    },
    countryCheckOptions () {
      return [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }].concat(this.countryOptions).filter(option => this.options.country.includes(option.title))
    },
    packingMethodCheckOptions () {
      return [
        { title: '散裝', value: 'bulk', style: { color: '#EF6577' } },
        { title: '有包裝', value: 'packed', style: { color: '#3967A6' } },
        { title: '截切', value: 'cut', style: { color: '#3967A6' } }
      ]
    },
    marketKindCheckOptions () {
      return [
        { title: '傳統市場', value: 'traditional_market' },
        { title: '批發市場', value: 'wholesale_market' },
        { title: '超市', value: 'supermarket' },
        { title: '量販店', value: 'hyper_market' },
        { title: '便利商店', value: 'convenience_store' },
        { title: '蔬果專賣店', value: 'vegetable_and_fruit_store' },
        { title: '農夫(假日)市集', value: 'farmers_market' }
      ]
    },
    xAxisGraphOptions () {
      let checkOptionTitles = this[this.filterConditions['xAxis'] + 'CheckOptions'].map(option => option.title)
      let dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      }
      let dataValues = this.datas.map(data => data[dataKeyMap[this.filterConditions['xAxis']]])
      return {
        createOptions: ['marketCountry', 'country'].includes(this.filterConditions['xAxis']) ? {
          title: '國家 (可選擇1-7個國家)',
          options: value => (['country'].includes(this.filterConditions['xAxis']) && !this.options.country.includes('無') ? [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }] : []).concat(this.countryOptions.filter(option => dataValues.includes(option.value) && !checkOptionTitles.includes(option.title))).filter(option => option.country.iso_name.toLowerCase().startsWith((value || '').toLowerCase()) || option.country.chinese_name.startsWith(value)).filter((_, index) => value || index < 99999),
          checkData: value => this.countryOptions.map(option => option.title).includes(value) || value === '無'
        } : null,
        checkOptions: {
          options: this[this.filterConditions['xAxis'] + 'CheckOptions'],
          values: this.filterConditions[this.filterConditions['xAxis']]
        }
      }
    },
    zAxisGraphOptions () {
      let checkOptionTitles = this[this.filterConditions['zAxis'] + 'CheckOptions'].map(option => option.title)
      let dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      }
      let dataValues = this.datas.map(data => data[dataKeyMap[this.filterConditions['zAxis']]])
      return {
        createOptions: ['marketCountry', 'country'].includes(this.filterConditions['zAxis']) ? {
          title: '國家 (可選擇1-7個國家)',
          options: value => (['country'].includes(this.filterConditions['zAxis']) && !this.options.country.includes('無') ? [{ title: '無', value: '無', country: { iso_name: '', chinese_name: '' } }] : []).concat(this.countryOptions.filter(option => dataValues.includes(option.value) && !checkOptionTitles.includes(option.title))).filter(option => option.country.iso_name.toLowerCase().startsWith((value || '').toLowerCase()) || option.country.chinese_name.startsWith(value)).filter((_, index) => value || index < 99999),
          checkData: value => this.countryOptions.map(option => option.title).includes(value) || value === '無'
        } : null,
        checkOptions: {
          options: this[this.filterConditions['zAxis'] + 'CheckOptions'],
          values: this.filterConditions[this.filterConditions['zAxis']]
        }
      }
    },
    zAxisLegends () {
      let legendDatas = this[this.filterConditions['zAxis'] + 'CheckOptions'].filter(option => this.filterConditions[this.filterConditions['zAxis']].includes(option.value))
      return legendDatas.map((data, index) => ({
        ...data,
        title: data.title.replace(/\(.+\)$/, ''),
        color: this.colors[1][index]
      }))
    },
    otherLegends () {
      let legendDatas = this['otherCheckOptions'].filter(option => this.filterConditions['other'].includes(option.value))
      return legendDatas.map((data, index) => ({
        ...data
      }))
    },
    chartOptions () {
      let datas = this.datas.map(data => ({
        ...data,
        country: data.country || '無'
      }))
      let maxPrice = 0
      let dataOffsetLength = length => {
        if (length >= 250) return 7
        if (length >= 600) return 9
        if (length >= 1000) return 11
        return 5
      }
      let yAxisMap = {
        single: [
          'bulk'
        ],
        all: [
          'packed',
          'cut'
        ]
      }
      let dataKeyMap = {
        country: 'country',
        id: 'id',
        marketCountry: 'market_country',
        marketKind: 'market_kind',
        packingMethod: 'packing_method',
        price: 'price',
        pricingMethod: 'pricing_method'
      }
      let filtedDatas = []
      let dateRange = [
        this.filterConditions['range'].start ? new Date(this.filterConditions['range'].start) : null,
        this.filterConditions['range'].end ? new Date(this.filterConditions['range'].end) : null
      ]
      let seriesGenerator = (symbol, color, offset = 0) => ({
        type: 'scatter',
        symbolSize: Math.sqrt(200),
        symbol: symbol,
        symbolOffset: [(offset * 5) + '&', 0],
        itemStyle: {
          color: color,
          opacity: 1,
          borderColor: '#777777',
          borderWidth: 1
        },
        data: []
      })
      let seriesMap = this.zAxisLegends.reduce((s, legend) => {
        return {
          ...s,
          [legend.value]: {
            price_by_weight: [
              seriesGenerator('circle', legend.color, 0),
              seriesGenerator('circle', legend.color, 1.5),
              seriesGenerator('circle', legend.color, -1.5),
              seriesGenerator('circle', legend.color, 2.5),
              seriesGenerator('circle', legend.color, -2.5),
              seriesGenerator('circle', legend.color, 3.5),
              seriesGenerator('circle', legend.color, -3.5),
              seriesGenerator('circle', legend.color, 4.5),
              seriesGenerator('circle', legend.color, -4.5),
              seriesGenerator('circle', legend.color, 5.5),
              seriesGenerator('circle', legend.color, -5.5)
            ],
            price_by_count: [
              seriesGenerator('triangle', legend.color, 0),
              seriesGenerator('triangle', legend.color, 1.5),
              seriesGenerator('triangle', legend.color, -1.5),
              seriesGenerator('triangle', legend.color, 2.5),
              seriesGenerator('triangle', legend.color, -2.5),
              seriesGenerator('triangle', legend.color, 3.5),
              seriesGenerator('triangle', legend.color, -3.5),
              seriesGenerator('triangle', legend.color, 4.5),
              seriesGenerator('triangle', legend.color, -4.5),
              seriesGenerator('triangle', legend.color, 5.5),
              seriesGenerator('triangle', legend.color, -5.5)
            ]
          }
        }
      }, {})
      for (let data of datas) {
        if (
          Array.prototype.concat.apply([], this.filterConditions['yAxis'].map(value => yAxisMap[value])).includes(data.packing_method) &&
          this.filterConditions['other'].includes(data.pricing_method)
        ) {
          let seriesKey = dataKeyMap[this.filterConditions['zAxis']]
          if (seriesMap[data[seriesKey]]) {
            let valueKey = dataKeyMap[this.filterConditions['xAxis']]
            let dataDate = data.date ? new Date(data.date) : null
            if (
              this.filterConditions[this.filterConditions['xAxis']].includes(data[valueKey]) &&
              (!dateRange[0] || dataDate > dateRange[0]) && (!dateRange[1] || dataDate < dateRange[1])
            ) {
              maxPrice = Math.max(maxPrice, data.price)
              let graphData = [data[valueKey], data.price, data.id]
              let generators = seriesMap[data[seriesKey]][data.pricing_method]
              let length = Math.min(dataOffsetLength(filtedDatas.length || this.datas.length), generators.length)
              generators[Math.floor(Math.random() * length)].data.push(graphData)
              filtedDatas.push(graphData)
            }
          }
        }
      }
      this.filtedDatas = filtedDatas
      let yAxisValueLength = Math.max(3, (maxPrice.toFixed(0) + '0').length)
      let xAxisLabelMap = this[this.filterConditions['xAxis'] + 'CheckOptions'].reduce((s, option) => ({ ...s, [option.value]: option.title.replace(/\(.+\)$/, '') }), {})
      return {
        xAxis: {
          type: 'category',
          // splitLine: {
          //   lineStyle: {
          //     type: 'dashed'
          //   }
          // },
          axisLabel: {
            formatter: value => xAxisLabelMap[value],
            interval: 0,
            fontSize: this.fontSize
          },
          axisTick: {
            alignWithLabel: true
          },
          name: this.xAxisOptions.find(option => option.value === this.filterConditions['xAxis']).title,
          nameLocation: 'middle',
          nameGap: 40,
          nameTextStyle: {
            fontSize: this.fontSize
          },
          data: this.filterConditions[this.filterConditions['xAxis']]
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize: this.fontSize
          },
          name: '價格 (美元)',
          nameLocation: 'middle',
          nameGap: yAxisValueLength * 10,
          nameTextStyle: {
            fontSize: this.fontSize
          }
        },
        grid: {
          top: 30,
          left: 30 + yAxisValueLength * 10,
          right: 10,
          bottom: 80
        },
        tooltip: {
          trigger: 'axis',
          showContent: false,
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: '#9BC737',
              opacity: 0.1
            }
          }
        },
        series: Array.prototype.concat.apply([], Object.values(seriesMap).map(wcMap => Array.prototype.concat.apply([], Object.values(wcMap))))
      }
    },
    // global
    dateFormat () { return dateFormat }
  },
  watch: {
    'datas' () {
      this.initCondition()
    }
  },
  created () {
    this.initCondition()
  },
  methods: {
    ...mapActions([
      'setModalAction'
    ]),
    initCondition () {
      this.options = {
        marketCountry: [],
        country: []
      }
      this.filterConditions = {
        xAxis: 'packingMethod',
        yAxis: [
          'single',
          'all'
        ],
        zAxis: 'marketKind',
        other: [
          'price_by_weight',
          'price_by_count'
        ],
        range: {
          start: '',
          end: ''
        },
        marketCountry: [],
        country: [],
        packingMethod: [
          'bulk',
          'packed',
          'cut'
        ],
        marketKind: [
          'traditional_market',
          'wholesale_market',
          'supermarket',
          'hyper_market',
          'convenience_store',
          'vegetable_and_fruit_store',
          'farmers_market'
        ]
      }
    },
    getFilterTitle (value) {
      if (!this.conditions.filters[value]) {
        return ''
      }
      return this.filterOptions.filters.find(filter => filter.value === value).options.find(option => option.value === this.conditions.filters[value]).title
    },
    chartOnClick (param) {
      let value = param.data[1]
      let xAxis = param.data[0]
      let filtedValues = this.filtedDatas.map(data => data[1])
      let interval = (Math.max.apply(null, filtedValues) - Math.min.apply(null, filtedValues)) / 10
      let ids = this.filtedDatas.filter(data => data[1] <= value + interval && data[1] >= value - interval && data[0] === xAxis).map(data => data[2])
      this.setModalAction({
        action: 'graphData',
        width: '820px',
        height: '90%',
        customStyles: {
          padding: '0px',
          margin: '20px auto',
          borderRadius: '0'
        },
        param: {
          ids: ids,
          defaultID: param.data[2],
          options: {
            country: this.countryOptions,
            packingMethod: this.packingMethodCheckOptions,
            marketKind: this.marketKindCheckOptions,
            quantity: [
              { title: '公克', value: 'gram', type: '重量' },
              { title: '公斤', value: 'kilogram', type: '重量' },
              { title: '磅', value: 'pound', type: '重量' },
              { title: '個', value: 'number', type: '數量' },
              { title: '包裝', value: 'package', type: '數量' }
            ]
          }
        }
      })
    },
    async downloadGraph (download = true) {
      let url = await html2DataUrl(this.$refs.chartField, 'png', 0.3)
      if (download) {
        let title = ''
        title = title + this.getFilterTitle('crop_name') + '的零售價格分析.png'
        await this.sendGraphAccessLog()
        downloadFile(title, url, '_blank')
      } else {
        return url
      }
    },
    async sendGraphAccessLog () {
      try {
        let config = this.$ls.get('userInfo')
        let type = 'product_prices'
        let paramInfos = {
          x: {
            value: this.xAxisOptions.find(option => option.value === this.filterConditions.xAxis).title,
            selected: this.filterConditions[this.filterConditions.xAxis].map(condition => this[this.filterConditions.xAxis + 'CheckOptions'].find(option => option.value === condition).title)
          },
          y: {
            value: '價格',
            selected: this.filterConditions.yAxis.map(condition => this.yAxisCheckOptions.find(option => option.value === condition).title)
          },
          z: {
            value: this.zAxisOptions.find(option => option.value === this.filterConditions.zAxis).title,
            selected: this.filterConditions[this.filterConditions.zAxis].map(condition => this[this.filterConditions.zAxis + 'CheckOptions'].find(option => option.value === condition).title)
          }
        }
        let data = {
          crop_name: this.getFilterTitle('crop_name'),
          chart_params_info: Object.entries(paramInfos).map(([title, info]) => title + ' = ' + info.value + ' (' + info.selected.join('、') + ')').join(', ')
        }
        await postAccessLog(type, data, config)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async downloadData () {
      let config = this.$ls.get('userInfo')
      let conditions = this.conditions.filters
      // let image = await this.downloadGraph(false)
      let data = {
        ...config,
        ...conditions
      }
      let url = API_ROOT + 'product_prices/export.zip'
      url = url + '?' + Object.entries(data).map(([key, value]) => value ? key + '=' + value : '').filter(x => x).join('&')
      downloadFile(null, url, '_target')
    }
  }
}
</script>

<style>
.echarts {
  width: 100% !important;
  height: 600px !important;
  min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/productPrice/graph.vue